import { useState } from "react";
import { Form, Button, Modal } from "antd"
import { EditOutlined } from "@ant-design/icons"
import CategoryForm from './form/CategoryForm';
import { categoryUpdateAsync } from "../../../app/store/reducers/category/categoryReducer";



const UpdateCategoryModal = ({category}) => {
    const [form] = Form.useForm()  
    const [show, setShow] = useState(false);
    const showModal = () => {
      if (category) {
        form.setFieldValue("name", category?.name)
      }
      setShow(true);
    };
    const handleCancel = () => {
      form.setFieldValue("name", "")
      setShow(false);
    };
  
    const onSubmit = async (values) => {
      console.log("values", values, category);
      await categoryUpdateAsync({id: category?.id, name: values?.name})
        .then(() => {
          handleCancel()
        })
        .catch(() => {
          
        })
    }
  
    const handleOk = () => {
      form
        .validateFields()
        .then((values) => {
          onSubmit(values)
          form.resetFields();
        })
        .catch((info) => {
          console.log("Validate Failed:", info);
        });
    };
  
  
    return (
      <>
        <Button style={{color: "orange", fontSize: "20px"}} className="d-flex align-items-center justify-content-center" onClick={showModal}>
            <EditOutlined />
        </Button>
        <Modal 
          title="Register Category" 
          open={show} 
          okText="Update"
          cancelText="Cancel"
          onOk={handleOk} 
          onCancel={handleCancel}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onSubmit}
          >
            <CategoryForm/>
            </Form>
        </Modal>
      </>
    );
}

export default UpdateCategoryModal